<template>
  <div card-holder :style="{ height }">
    <div card-holder-inner>
      <slot/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import responsive from '@/utils/responsive';

export default {
  name: 'CardHolder',
  data() {
    return {
      inner: null,
      bottoms: null,
      height: 'auto',
      section: null,
    };
  },
  methods: {
    setPosition(card) {
      const w = card.size[this.section];
      const len = 6 - w + 1;
      let i, j, t0, position = 0, bottom = Number.MAX_VALUE;

      for (i = 0 ; i < len ; ++i) {
        t0 = 0;
        for (j = i ; j < i + w ; ++j) {
          if (t0 < this.bottoms[j]) t0 = this.bottoms[j];
        }
        if (t0 < bottom) {
          position = i;
          bottom = t0;
        }
      }

      card.style.width = `${100 / 6 * w}%`;
      card.style.top = `${bottom}px`;
      card.style.left = `${100 / 6 * position}%`;

      bottom += card.offsetHeight;

      for (i = position; i < position + w; ++i) {
        this.bottoms[i] = bottom;
      }
    },
    resized() {
      this.bottoms = [0,0,0,0,0,0];
      this.section = this.sect === 'xxl' ? 'xl' : this.sect;
      _.forEach(this.inner.childNodes , this.setPosition);
      // this.height = `${_.max(this.bottoms)}px`;
    },
  },
  mounted() {
    this.inner = this.$el.querySelector('[card-holder-inner]');
    responsive.addListener(this.resized);
  },
  beforeDestroy() {
    responsive.removeListener(this.resized);
  },
  beforeUpdate() {
    this.$nextTick(this.resized);
  },
};
</script>

<style lang="less">
@import "~@/less/proj";
[card-holder] { .p(0,20); .mb(-20);
  [card-holder-inner] { .rel; .ib-list;
    // > * { .abs; }
  }
}
@media (min-width: @screen-md-min) {
  [card-holder] { .p(0,21);
    &.wide { .p(0,11); }
  }
}

@media (min-width: @screen-lg-min) {
  [card-holder] { .p(0,25); .mb(-30);
    &.wide { .p(0,20); }
  }
}

@media (min-width: @screen-xl-min) {
  [card-holder] { .p(0,20); .w(1320); .mh-c; .mb(-40);
    &.wide { .p(0); .w; }
  }
}

</style>
